 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		64: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		64: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors","1":"layouts__AuthLayout","2":"layouts__BlankLayout","3":"layouts__CaLayout","4":"layouts__LandingLayout","5":"layouts__OdLayout","6":"layouts__TranslationLayout","7":"layouts__UserLayout","8":"p__403","9":"p__404","10":"p__500","11":"p__ca__cart","12":"p__ca__cart__model.ts","13":"p__ca__deals__list__model.ts","14":"p__ca__deals__view__model.ts","15":"p__ca__dishes__list__model.ts","16":"p__ca__dishes__view__model.ts","17":"p__ca__events__list__model.ts","18":"p__ca__events__view__model.ts","19":"p__ca__group__model.ts","20":"p__ca__home__model.ts","21":"p__ca__menus__list__model.ts","22":"p__ca__menus__view__model.ts","23":"p__ca__order__invoice__model.ts","24":"p__ca__order__payment__model.ts","25":"p__ca__order__process__model.ts","26":"p__ca__previous-order","27":"p__ca__previous-order__model.ts","28":"p__ca__restaurant-details__model.ts","29":"p__landing__model.ts","30":"p__od__analytics__sales__summary__model.ts","31":"p__od__campaign__deals__edit__model.ts","32":"p__od__campaign__deals__view__model.ts","33":"p__od__campaign__events__edit__model.ts","34":"p__od__campaign__events__view__model.ts","35":"p__od__dashboard__model.ts","36":"p__od__management__dish-types__edit__model.ts","37":"p__od__management__dish-types__view__model.ts","38":"p__od__management__dishes__edit__model.ts","39":"p__od__management__dishes__view__model.ts","40":"p__od__management__menus__edit__model.ts","41":"p__od__management__menus__view__model.ts","42":"p__od__management__modifications__edit__model.ts","43":"p__od__management__modifications__view__model.ts","44":"p__od__management__modifiers__edit__model.ts","45":"p__od__management__modifiers__view__model.ts","46":"p__od__marketing__coupons__edit__model.ts","47":"p__od__marketing__coupons__view__model.ts","48":"p__od__orders__bill__model.ts","49":"p__od__orders__invoice__model.ts","50":"p__od__orders__order-processing__model.ts","51":"p__od__settings__business__model.ts","52":"p__od__settings__personal__model.ts","53":"p__od__settings__print__model.ts","54":"p__user__claim__model.ts","55":"p__user__contact__model.ts","56":"p__user__forget__model.ts","57":"p__user__login__model.ts","58":"p__user__package__checkout__model.ts","59":"p__user__package__pay__model.ts","60":"p__user__package__subscription__model.ts","61":"p__user__register__model.ts","62":"p__welcome__ca","63":"p__welcome__ca__model.ts","65":"viz"}[chunkId]||chunkId) + "." + {"0":"d41db903","1":"d28f4638","2":"cc46566b","3":"1c558e70","4":"889996ed","5":"67e8fac9","6":"2da96c12","7":"e8e61960","8":"3f6ffa4e","9":"f33ac9cd","10":"3e92dd80","11":"d2428f86","12":"6fe5314b","13":"1c21aaed","14":"0b1aca15","15":"848a8759","16":"41b397f9","17":"4e1313c2","18":"421efc0a","19":"01d607aa","20":"2e43f6cf","21":"813fa436","22":"e0e29800","23":"920d27bc","24":"4631096e","25":"ef136b0f","26":"0d3f8dc0","27":"0a77a3c8","28":"3479a695","29":"dc372518","30":"8cbe8fb5","31":"54ad7efc","32":"df78c2c9","33":"7ebf1618","34":"c8aa4ff6","35":"1aacd045","36":"08eb0490","37":"f08ee779","38":"e0f2fb8f","39":"7e22795a","40":"cd375ebe","41":"a4ab7478","42":"111fed1e","43":"2f67ee67","44":"641f9aad","45":"107ad6e1","46":"f9847fb9","47":"acef2c9a","48":"a0b08e94","49":"035771e1","50":"c2fb49ae","51":"bdb6e8da","52":"b397f30d","53":"3ccb6cc6","54":"43f7deaf","55":"fab39ad9","56":"488ab820","57":"ae74dba9","58":"9f6b4864","59":"663eb28e","60":"c096893e","61":"2b31d7f3","62":"81720d8b","63":"4da7368c","65":"88852687"}[chunkId] + ".async.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"3":1,"4":1,"5":1,"7":1,"11":1,"26":1,"62":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors","1":"layouts__AuthLayout","2":"layouts__BlankLayout","3":"layouts__CaLayout","4":"layouts__LandingLayout","5":"layouts__OdLayout","6":"layouts__TranslationLayout","7":"layouts__UserLayout","8":"p__403","9":"p__404","10":"p__500","11":"p__ca__cart","12":"p__ca__cart__model.ts","13":"p__ca__deals__list__model.ts","14":"p__ca__deals__view__model.ts","15":"p__ca__dishes__list__model.ts","16":"p__ca__dishes__view__model.ts","17":"p__ca__events__list__model.ts","18":"p__ca__events__view__model.ts","19":"p__ca__group__model.ts","20":"p__ca__home__model.ts","21":"p__ca__menus__list__model.ts","22":"p__ca__menus__view__model.ts","23":"p__ca__order__invoice__model.ts","24":"p__ca__order__payment__model.ts","25":"p__ca__order__process__model.ts","26":"p__ca__previous-order","27":"p__ca__previous-order__model.ts","28":"p__ca__restaurant-details__model.ts","29":"p__landing__model.ts","30":"p__od__analytics__sales__summary__model.ts","31":"p__od__campaign__deals__edit__model.ts","32":"p__od__campaign__deals__view__model.ts","33":"p__od__campaign__events__edit__model.ts","34":"p__od__campaign__events__view__model.ts","35":"p__od__dashboard__model.ts","36":"p__od__management__dish-types__edit__model.ts","37":"p__od__management__dish-types__view__model.ts","38":"p__od__management__dishes__edit__model.ts","39":"p__od__management__dishes__view__model.ts","40":"p__od__management__menus__edit__model.ts","41":"p__od__management__menus__view__model.ts","42":"p__od__management__modifications__edit__model.ts","43":"p__od__management__modifications__view__model.ts","44":"p__od__management__modifiers__edit__model.ts","45":"p__od__management__modifiers__view__model.ts","46":"p__od__marketing__coupons__edit__model.ts","47":"p__od__marketing__coupons__view__model.ts","48":"p__od__orders__bill__model.ts","49":"p__od__orders__invoice__model.ts","50":"p__od__orders__order-processing__model.ts","51":"p__od__settings__business__model.ts","52":"p__od__settings__personal__model.ts","53":"p__od__settings__print__model.ts","54":"p__user__claim__model.ts","55":"p__user__contact__model.ts","56":"p__user__forget__model.ts","57":"p__user__login__model.ts","58":"p__user__package__checkout__model.ts","59":"p__user__package__pay__model.ts","60":"p__user__package__subscription__model.ts","61":"p__user__register__model.ts","62":"p__welcome__ca","63":"p__welcome__ca__model.ts","65":"viz"}[chunkId]||chunkId) + "." + {"0":"ccb37bec","1":"31d6cfe0","2":"31d6cfe0","3":"dedf0311","4":"8259692b","5":"5c424e6c","6":"31d6cfe0","7":"912fcb1d","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"03fccf31","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"31d6cfe0","20":"31d6cfe0","21":"31d6cfe0","22":"31d6cfe0","23":"31d6cfe0","24":"31d6cfe0","25":"31d6cfe0","26":"b8924498","27":"31d6cfe0","28":"31d6cfe0","29":"31d6cfe0","30":"31d6cfe0","31":"31d6cfe0","32":"31d6cfe0","33":"31d6cfe0","34":"31d6cfe0","35":"31d6cfe0","36":"31d6cfe0","37":"31d6cfe0","38":"31d6cfe0","39":"31d6cfe0","40":"31d6cfe0","41":"31d6cfe0","42":"31d6cfe0","43":"31d6cfe0","44":"31d6cfe0","45":"31d6cfe0","46":"31d6cfe0","47":"31d6cfe0","48":"31d6cfe0","49":"31d6cfe0","50":"31d6cfe0","51":"31d6cfe0","52":"31d6cfe0","53":"31d6cfe0","54":"31d6cfe0","55":"31d6cfe0","56":"31d6cfe0","57":"31d6cfe0","58":"31d6cfe0","59":"31d6cfe0","60":"31d6cfe0","61":"31d6cfe0","62":"aef88500","63":"31d6cfe0","65":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 1);
